module.exports = __webpack_public_path__ + "static/media/icone_handicap.0dc1a3ea.svg";